import { PlatformEnum } from '@vacationtracker/shared/data/platforms'

import { ConnectPlatform } from './types'

/**
 * Brand names are never translated, so they are interpolated rather than stored as copy.
 * `short` names the button, `full` names the product in a failure message.
 */
export const PLATFORM_BRAND: Record<ConnectPlatform, { short: string; full: string }> = {
  [PlatformEnum.Slack]: { short: 'Slack', full: 'Slack' },
  [PlatformEnum.Microsoft]: { short: 'Microsoft', full: 'Microsoft Teams' },
  [PlatformEnum.Google]: { short: 'Google', full: 'Google' },
}
